module.exports = __webpack_public_path__ + "static/img/mobile-web-main-01@w.6c7e12b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/mobile-web-main-01@w.png
// module id = sOac
// module chunks = 0